import React from 'react';
import { connect } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faFrownOpen,
  faWifiSlash,
  faExclamationTriangle,
  faFileExcel,
  faBoneBreak,
} from '@fortawesome/pro-duotone-svg-icons';

const Error = ({
  status,
  tab,
}) => {
  const getErrorDetails = (errorStatus) => {
    switch (errorStatus) {
      case 'rejected_file_type':
        return {
          icon: faFileExcel,
          name: 'Bad File Type',
          message: 'Please select a .CSV file to upload.',
        };
      case 'error_file_size':
        return {
          icon: faExclamationTriangle,
          name: 'File Too Large',
          message: 'Please upload a smaller file.',
        };
      case 'exception_upload':
        return {
          icon: faWifiSlash,
          name: 'No Internet!',
          message: 'A network error has occurred. Please check your connection and try again.',
        };
      case 'error_upload':
        return {
          icon: faBoneBreak,
          name: 'Server Error 500',
          message: 'Something went wrong. Please ensure your file is valid and try again.',
        };
      case 'error_validation':
        return {
          icon: faExclamationTriangle,
          name: 'Option Not Selected',
          message: `Please select an Agent Group to associate these ${tab} with.`,
        };
      case 'Could not process the file. line contains NULL byte':
        return {
          icon: faExclamationTriangle,
          name: '',
          message: 'Could not process the file. line contains NULL byte.',
        };
      default:
        return {
          icon: faFrownOpen,
          name: '???',
          message: 'Something went wrong. Please refresh the page and try again.',
        };
    }
  };
  const error = getErrorDetails(status);

  return (
    <div className="text-center">
      <div className="bg-danger text-white p-3">
        <div>
          <FontAwesomeIcon icon={error.icon} size="3x" />
        </div>
        <h5 className="mt-2 mb-0">
          {error.name}
        </h5>
      </div>
      <h5 className="mt-4">
        {error.message}
      </h5>
    </div>
  );
};

const mapStateToProps = (store) => ({
  tab: store.batch.tab,
});

export default connect(mapStateToProps)(Error);
